import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IfiSimulationRequest } from '../interfaces/ifi-simulation-request';
import { IfiSimulationResponse } from '../interfaces/ifi-simulation-response.interface';

@Injectable({
  providedIn: 'root',
})
export class IfiSimulationService {
  private readonly http = inject(HttpClient);

  public postIfiSimulation(
    ifiSimulationRequest: Partial<IfiSimulationRequest>,
  ): Observable<IfiSimulationResponse> {
    return this.http.post<IfiSimulationResponse>(
      '/rgg/fis/v1/ifi-simulation',
      ifiSimulationRequest,
    );
  }
}
